import classNames from 'classnames';
import styled from 'styled-components';
import { colors, spacing } from '../../style';
import Input, { InputProps } from './input';

interface InputWithCounterProps extends InputProps {
  minLength?: number;
}

const InputWithCounterComponent = ({
  componentClass = 'textarea',
  maxLength,
  minLength,
  value,
  className,
  ...rest
}: InputWithCounterProps) => {
  const isMinLengthValid = minLength ? value?.length >= minLength : true;
  const isMaxLengthValid = maxLength ? value?.length <= maxLength : true;

  return (
    <div className={classNames('box-field-with-counter', className)}>
      <Input componentClass={componentClass} maxLength={maxLength} value={value} {...rest} />
      {(maxLength || minLength) && (
        <span
          aria-live={'polite'}
          data-name={'counter'}
          className={classNames('counter', { error: !isMaxLengthValid || !isMinLengthValid })}
        >
          {value?.length || 0} / {minLength && `${minLength} - `}
          {maxLength}
        </span>
      )}
    </div>
  );
};

const InputWithCounter = styled(InputWithCounterComponent)<InputWithCounterProps>`
  &.box-field-with-counter {
    position: relative;

    textarea,
    input {
      padding-right: ${spacing['3xxl']};
    }

    .counter {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: ${colors.gray600};
      font-size: 0.875rem;
    }
  }
`;

export default InputWithCounter;
